export const WITHDRAWAL_TRANSLATION = 'withdrawal';
